export default "__VITE_ASSET__BMW4bpdV__"